


























































































































import { PropertyData } from '@beyondview/firebase-client-8';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { MetaInfo } from 'vue-meta';
import { BModal } from 'bootstrap-vue';

import { locationSortKey } from '@/filters';
import { Child, Option } from '@/types';

import CreatePropertyModal from '@/components/modals/CreatePropertyModal.vue';

interface ComponentData {
	loading: boolean,
	propertiesSearch: string,
	sort: string,
	sortBy?: string,
	sortOptions: Option[],
	sortDescriptions: { [ key: string ]: string },
	filter: string,
	filterOptions: Option[],
	filterDescriptions: {
		active: string,
		archived: string
	},
	children: Child[]
}

export default Vue.extend( {
	components: {
		CreatePropertyModal
	},
	data(): ComponentData {
		return {
			loading: true,
			sort: 'updated-desc',
			propertiesSearch: '',
			sortOptions: [
				{
					text: this.$t( 'views.properties-view.updated' ).toString(),
					value: 'updated-desc'
				},
				{
					text: this.$t( 'views.properties-view.created' ).toString(),
					value: 'created-desc'
				},
				{
					text: this.$t( 'views.properties-view.location' ).toString(),
					value: 'location-asc'
				}
			],
			sortDescriptions: {
				'updated-desc': this.$t( 'views.properties-view.recently-updated' ).toString(),
				'created-desc': this.$t( 'views.properties-view.recently-created' ).toString(),
				'location-asc': this.$t( 'views.properties-view.a-z' ).toString()
			},
			filter: 'active',
			filterOptions: [
				{
					text: this.$t( 'views.properties-view.active' ).toString(),
					value: 'active'
				},
				{
					text: this.$t( 'views.properties-view.archived' ).toString(),
					value: 'archived'
				}
			],
			filterDescriptions: {
				active: this.$t( 'views.properties-view.active-properties' ).toString(),
				archived: this.$t( 'views.properties-view.archived-properties' ).toString()
			},
			children: [
				{
					key: 'list',
					name: 'Properties List',
					title: this.$t( 'views.properties-view.list' ).toString(),
					icon: 'view-stacked',
					filterable: true,
					sortable: true
				},
				{
					key: 'table',
					name: 'Properties Table',
					title: this.$t( 'views.properties-view.table' ).toString(),
					icon: 'view-list',
					filterable: true
				},
				{
					key: 'map',
					name: 'Properties Map',
					title: this.$t( 'views.properties-view.map' ).toString(),
					icon: 'geo-alt',
					filterable: true
				}
			]
		};
	},
	head(): MetaInfo {
		return {
			title: `${this.$t( 'views.properties-view.properties' )}`
		};
	},
	computed: {
		...mapGetters( [ 'userIsAdmin', 'userIsStaff', 'propertyRoles', 'customerRole' ] ),
		child(): Child | undefined {
			return this.children.find( child => child.name === this.$route.name );
		},
		properties(): PropertyData[] {
			const { filter, sort, propertiesSearch } = this;
			let properties = this.$store.getters.properties;
			if ( this.child ) {
				if ( this.child.filterable ) {
					properties = properties.filter( ( property: PropertyData ) => {
						return property.flags.includes( PropertyData.Flags.Archived ) ===
							( filter === 'archived' );
					} );
				}

				if ( this.child.sortable ) {
					const [ key, direction ] = sort.split( '-' );
					const factor = direction === 'desc' ? -1 : 1;
					if ( key === 'location' ) {
						// TODO: Type a and b as property documents
						properties.sort( ( a: any, b: any ) => {
							a = a.location ? locationSortKey( a.location ) : null;
							b = b.location ? locationSortKey( b.location ) : null;
							if ( a < b ) {
								return -1 * factor;
							} else if ( a[ key ] > b[ key ] ) {
								return 1 * factor;
							}
							return 0;
						} );
					} else {
						// TODO: Type a and b as property documents
						properties.sort( ( a: any, b: any ) => {
							return ( a[ key ] - b[ key ] ) * factor;
						} );
					}
				}
			}
			if ( propertiesSearch ) {
				return properties.filter(
					( property: PropertyData ) => {
						const keywords = [
							...Object.values( property.location ),
							property.title
						].join( ' ' );
						return keywords.toUpperCase().includes( propertiesSearch.toUpperCase() );
					}
				);
			}
			return properties;
		}
	},
	async created() {
		await this.$store.dispatch( 'bindProperties' );
		this.loading = false;
	},
	methods: {
		handleAddressInput( query: string ) {
			this.propertiesSearch = query;
		},
		async addItem() {
			const property = await ( this.$refs as BModal ).createPropertyModal.show();
			if ( property ) {
				await this.$router.push( `properties/${property.id}` );
			}
		}
	}
} );
